export const scrollToRef = ref => ref && window.scrollTo(0, ref.current.offsetTop - 80);
